"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChannelRow = exports.ShareNotificationCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../commands");
const CardHelper_1 = require("../utils/CardHelper");
const ShareNotificationCard = (applicationType, action, title, details, verb, initiatorName, recipientName, recipientType) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `🔔 ${action}`,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: title,
        size: adaptivecards_1.TextSize.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
    }));
    if (details) {
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: details,
            separator: true,
            wrap: true,
            isSubtle: true,
        }));
    }
    const container = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    card.addItem(container);
    const initiatorRow = getInitiatorRow(applicationType, verb, initiatorName);
    container.addItem(initiatorRow);
    if (recipientName && recipientType) {
        const channelRow = (0, exports.getChannelRow)(applicationType, recipientType, recipientName);
        container.addItem(channelRow);
    }
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
};
exports.ShareNotificationCard = ShareNotificationCard;
const getInitiatorRow = (applicationType, verb, initiatorName) => {
    const initiatorRow = new adaptivecards_1.ColumnSet();
    const verbColumn = new adaptivecards_1.Column();
    const verbText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `${verb} by:`,
        weight: adaptivecards_1.TextWeight.Bolder,
    });
    verbColumn.addItem(verbText);
    initiatorRow.addColumn(verbColumn);
    const userIconColumn = new adaptivecards_1.Column("auto");
    const userIcon = CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: (0, CardHelper_1.getImageCardUrl)("AVATAR", applicationType),
    });
    userIconColumn.addItem(userIcon);
    initiatorRow.addColumn(userIconColumn);
    const userNameColumn = new adaptivecards_1.Column();
    const userNameText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: initiatorName,
    });
    userNameColumn.addItem(userNameText);
    initiatorRow.addColumn(userNameColumn);
    return initiatorRow;
};
const getChannelRow = (applicationType, recipientType, recipientName) => {
    const channelRow = new adaptivecards_1.ColumnSet();
    const locationColumn = new adaptivecards_1.Column("auto");
    const locationText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: getlocationTitle(recipientType),
        weight: adaptivecards_1.TextWeight.Bolder,
    });
    locationColumn.addItem(locationText);
    channelRow.addColumn(locationColumn);
    const teamIconColumn = new adaptivecards_1.Column("auto");
    const teamIcon = CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: (0, CardHelper_1.getImageCardUrl)("CHANNEL_ICON", applicationType),
    });
    teamIconColumn.addItem(teamIcon);
    channelRow.addColumn(teamIconColumn);
    const recipientNameColumn = new adaptivecards_1.Column("auto");
    const userNameText = CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: recipientName,
    });
    recipientNameColumn.addItem(userNameText);
    channelRow.addColumn(recipientNameColumn);
    return channelRow;
};
exports.getChannelRow = getChannelRow;
const getlocationTitle = (recipientType) => {
    switch (recipientType) {
        case "channel":
            return "In channel:";
        case "groupChat":
            return "In group chat:";
        case "user":
            return "In chat:";
    }
};
//# sourceMappingURL=ShareNotificationCard.js.map